/**
 * GmOrchestratorServiceStandalone — V3 Voice GM (2026-06-02).
 *
 * STUB pending M4. The standalone HTML build target has no per-tenant
 * LLM router available; M4 may either ship a Web Speech recognition +
 * client-side rules engine, OR a remote LLM API path. Until then,
 * dispatch() rejects with GmOrchestratorError so the UI hides the
 * orchestrator-driven affordances when isAvailable() returns false.
 */
import {
  GmOrchestratorError,
  type DispatchRequest,
  type DispatchResponse,
  type GmOrchestratorService,
} from '../types';

export class GmOrchestratorServiceStandalone implements GmOrchestratorService {
  isAvailable(): boolean {
    return false;
  }

  async dispatch(_req: DispatchRequest): Promise<DispatchResponse> {
    throw new GmOrchestratorError(
      'standalone_unavailable',
      0,
      'GMOrchestrator unavailable in standalone build (M4 pending)',
    );
  }
}
